/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    alternative: { type: 'variant', values: [ true ] },
    inverse: { type: 'variant', values: [ true ] },
    outline: { type: 'variant', values: [ true ] },
    purpose: { type: 'variant', values: [ 'offer', 'editorial', 'subtle' ] },
    size: { type: 'variant', values: [ 'compact' ] }
  },
  rules: [
    {
      if: { inverse: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: '#ffffff',
        color: '#ffffff'
      }
    },
    {
      if: { outline: true },
      tokens: { backgroundColor: '#ffffff', color: '#613889' }
    },
    {
      if: { alternative: true },
      tokens: {
        borderColor: 'rgba(0, 0, 0, 0)',
        gradient: {
          angle: 135,
          stops: [
            { color: '#00784a', hint: 0.75, stop: 0 },
            { color: '#66cc00', stop: 1 }
          ],
          type: 'linear'
        }
      }
    },
    {
      if: { purpose: 'subtle' },
      tokens: {
        backgroundColor: '#7c53a5',
        borderColor: '#7c53a5',
        color: '#ffffff'
      }
    },
    {
      if: { purpose: 'offer' },
      tokens: {
        borderWidth: 0,
        gradient: {
          angle: 135,
          stops: [
            { color: '#4b286d', hint: 0.75, stop: 0 },
            { color: '#e53293', stop: 1 }
          ],
          type: 'linear'
        },
        paddingBottom: 4,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 4
      }
    },
    {
      if: { purpose: 'editorial' },
      tokens: {
        backgroundColor: '#676e73',
        borderColor: '#676e73',
        color: '#ffffff'
      }
    },
    {
      if: { outline: true, purpose: 'subtle' },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: '#7c53a5',
        color: '#7c53a5'
      }
    },
    {
      if: { outline: true, purpose: 'editorial' },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: '#676e73',
        color: '#676e73'
      }
    },
    {
      if: { outline: true, purpose: 'offer' },
      tokens: {
        borderColor: 'rgba(0, 0, 0, 0)',
        borderWidth: 2,
        gradient: {
          angle: 135,
          stops: [
            { color: '#4b286d', hint: 0.75, stop: 0 },
            { color: '#e53293', stop: 1 }
          ],
          type: 'linear'
        },
        paddingBottom: 2,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 2
      }
    },
    {
      if: { size: 'compact' },
      tokens: {
        fontSize: 12,
        paddingBottom: 0,
        paddingLeft: 3,
        paddingRight: 3,
        paddingTop: 0
      }
    },
    {
      if: { purpose: 'offer', size: 'compact' },
      tokens: {
        fontSize: 12,
        paddingBottom: 2,
        paddingLeft: 3,
        paddingRight: 3,
        paddingTop: 2
      }
    }
  ],
  tokens: {
    backgroundColor: '#613889',
    borderColor: '#613889',
    borderRadius: 4,
    borderWidth: 2,
    color: '#ffffff',
    fontName: 'HNforTELUSSA',
    fontSize: 12,
    fontWeight: '700',
    gradient: null,
    paddingBottom: 2,
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 2
  }
}
export default theme
